module.exports = __webpack_public_path__ + "img/image_6.089a7ac8.jpg";